module.exports = __webpack_public_path__ + "media/mypage/images/special/009-50fd4cd34d38c390025778b9ec3e4326.jpg";